import { dispatchEvent } from '@/helpers/DispatchEvent';
import { languageItem } from '@/language/helpers';
const sameAs = {
    inserted(confirmEl, { value, modifiers }) {
        function compare(a, b) {
            if (modifiers.anyCase) {
                return a.toLowerCase() === b.toLowerCase();
            }
            else {
                return a === b;
            }
        }
        if (!(confirmEl instanceof HTMLInputElement)) {
            throw new Error('The sameAs directive (v-same-as="") is only compatible with HTML <input> elements.');
        }
        // `value` is the value of the v-same-as="" attribute.
        // E.g. <input v-same-as="VALUE" />
        if (value) {
            const sourceEl = document.querySelector(`input[name=${value}]`);
            const checkValidity = () => {
                if (compare(sourceEl.value, confirmEl.value)) {
                    confirmEl.setCustomValidity('');
                }
                else {
                    const language = languageItem('validationMessages');
                    const key = `${value}MustMatch`;
                    confirmEl.setCustomValidity(language[key]);
                }
            };
            confirmEl.addEventListener('change', checkValidity);
            sourceEl.addEventListener('change', checkValidity);
            sourceEl.addEventListener('blur', () => {
                if (confirmEl.value)
                    dispatchEvent('validate', confirmEl);
            });
        }
    },
};
export default sameAs;
